import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { InputStatus } from '../../../../../../../../__legacy__/models/error.model';
import { FieldStatus } from '../../../../../../../../design/fields/FieldStatus';
import { S_TextField } from '../../../../../../../../design/fields/textField/S_TextField';

interface Props {
  name: string;
  changeName: (name: string) => void;
  nameStatus: InputStatus;
  disabled?: boolean;
}

export const NameField = observer((props: Props): ReactElement => {
  const { t } = useTranslator();
  return (
    <S_TextField
      isRequired
      id='annotation-tool-name-input'
      labelText={t('name')}
      placeholder={t('projects.details.annotation_tools.marking_tools.name')}
      value={props.name}
      onChange={props.changeName}
      fieldStatus={new FieldStatus(props.nameStatus.isValid, props.nameStatus.errorCodes)}
      disabled={props.disabled}
    />
  );
});
